/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const wanchain_chain_about = () => `Wanchain is the longest-running decentralized interoperability solution. Founded in 2017, Wanchain is committed to driving blockchain adoption by unifying isolated networks. While connecting the industry's siloed networks, Wanchain strives to accelerate the development of a scalable, industry-wide blockchain interoperability standard. To date, Wanchain's infrastructure connects more than 35 EVM and non-EVM networks while sporting top-grade security and industry-best uptime.`
